import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const UserContext = createContext()

const UserProvider = ({ children }) => {

    const { headers, toast } = useAuth();

    const getAllUsers = async (filter) => {
        try {
            const { role, restaurant_id, limit, totalRenderedRecords } = filter

            let { data } = await axios.get(`${baseURL}/user/list?role=${role}&restaurant_id=${restaurant_id ? restaurant_id : null}&limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&is_web=true`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const permissionMaster = async (filter) => {
        try {
            const { role } = filter

            let { data } = await axios.get(`${baseURL}/user/permission/list?type=${role}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleUser = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/user/single-user/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createUser = async (userDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/user/create`, userDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'User', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateUser = async (id, userDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/user/update/${id}`, userDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'User', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'User', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteUser = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/user/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const archiveUser = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/user/archive/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const updatePin = async (id, newPin) => {
        try {
            const { data } = await axios.put(`${baseURL}/user/update/pin/${id}`, { pin: newPin }, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'User', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updatePassword = async (id, newPassword) => {
        try {
            const { data } = await axios.put(`${baseURL}/user/update/password/${id}`, { password: newPassword }, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Users', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Users', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Users', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Users', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const createUserShift = async (userShiftDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/user/create/shift`, userShiftDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Shift', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'User Shift', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateUserShift = async (id, userShiftDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/user/update/shift/${id}`, userShiftDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Shift', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'User Shift', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'User Shift', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const userShiftClockOut = async (id) => {
        try {
            const { data } = await axios.put(`${baseURL}/user/update/shift/clock-out/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Shift', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'User Shift', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'User Shift', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Shift', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const getSingleUserShift = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/user/single-user-shift/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Shift', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <UserContext.Provider value={{ getAllUsers, getSingleUser, getSingleUserShift, createUser, createUserShift, updateUser, updateUserShift, userShiftClockOut, deleteUser, archiveUser, updatePin, updatePassword, permissionMaster }}>
            {children}
        </UserContext.Provider>
    )
}

const useUser = () => useContext(UserContext)

export { useUser, UserProvider }